module.exports = __webpack_public_path__ + "img/style_10_pl.ded3bb41.jpeg";